// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventProvisioningCredentialData
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Bstr

fun EventProvisioningCredentialData.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "mXuPwK9ageIgwO6vcbLeQ2Hvv2bxV22A1FSkLyI7PLg")
val EventProvisioningCredentialData_cborSchemaId = ByteString(-103, 123, -113, -64, -81, 90, -127, -30, 32, -64, -18, -81, 113, -78, -34, 67, 97, -17, -65, 102, -15, 87, 109, -128, -44, 84, -92, 47, 34, 59, 60, -72)

fun EventProvisioningCredentialData.Companion.fromCbor(data: ByteArray): EventProvisioningCredentialData {
    return EventProvisioningCredentialData.fromDataItem(Cbor.decode(data))
}

val EventProvisioningCredentialData.Companion.cborSchemaId: ByteString
    get() = EventProvisioningCredentialData_cborSchemaId

fun EventProvisioningCredentialData.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("issuerProvidedData", Bstr(this.issuerProvidedData.toByteArray()))
    return builder.end().build()
}

fun EventProvisioningCredentialData.Companion.fromDataItem(dataItem: DataItem): EventProvisioningCredentialData {
    val issuerProvidedData = ByteString(dataItem["issuerProvidedData"].asBstr)
    return EventProvisioningCredentialData(
        issuerProvidedData = issuerProvidedData,
    )
}
